import React, { FC } from 'react'
import { Typography } from '@material-ui/core'

import { useServices } from '../../hooks'

export const AppVersion: FC = () => {
    const { configuration } = useServices()
    return <Typography variant="body1">{configuration.getAppVersion()}</Typography>
}
